import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { ApiService } from './api.service';
@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(private apiService: ApiService, public router: Router) {}
  canActivate(): boolean {
    console.log(ApiService.permission)
    if (!ApiService.permission) {
    	console.log(ApiService.permission)
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}